import request from '@/utils/request'

// 查询资产盘点列表
export function queryAssetInventory(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/assetInventory/queryAssetInventory',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询仓库列表
export function queryShopHouse(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopHouse.queryShopHouse',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除资产盘点
export function deleteAssetInventory(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/assetInventory/deleteAssetInventory',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}